import * as io from "io-ts";

/**
 * @todo correlate with Quantity / Fault schema.
 */
export const GUIQuantityColumns = io.keyof({
  measured: null,
  std: null,
  expected: null,
  gap: null,
  normalizedGap: null,
});
export type GUIQuantityColumnsT = io.TypeOf<typeof GUIQuantityColumns>;

export const GUIFaultColumns = io.keyof({
  real: null,
  globalImpact: null,
  quantityImpacts: null,
});
export type GUIFaultColumnsT = io.TypeOf<typeof GUIFaultColumns>;

export const GUIDisplayColumns = io.keyof({
  label: null,
  group: null,
  validity: null,
  faultStatus: null,
});
export type GUIDisplayColumnsT = io.TypeOf<typeof GUIDisplayColumns>;
